import type { FaireProductEntity } from "../../entity_types/product";

export const p_eeud6suzkf: FaireProductEntity = {
  token: "p_eeud6suzkf",
  type: "product",
  name: "Iridescent Sequin Wing Beaded Statement Earrings",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/8732ac3ac512ae9243db70cdcf7b2554d17c51b52427ee1036d1bbdd0c0a22dd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a2cc0a57eba3b84443149a2387d40538532620f3d669a75f1059e0dc8dadc193.jpeg",
    "https://cdn.faire.com/fastly/1935d93c9d27a13cb2a0ed7dbbe8700df610104b8ee2b1b0715165ef87e26e8f.jpeg",
    "https://cdn.faire.com/fastly/9fd0aa3e6d4e3ed090ed8030cdfb52427fc06ad602c5c164f392c33c029dffdd.jpeg"
  ],
  priceDollars: 14,
  description: "Iridescent Sequin Wing Beaded Earrings - Brookhaven Baubles - Southern Statement Jewelry - Beaded Statement Earrings\n\nIridescent Wing Beaded Earrings - Southern Statement Jewelry - Beaded Statement Earrings - Fashion Earrings for Her \n\nThese lightweight earrings are made from acrylic seed beads that you will practically forget you are wearing them.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\n\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:09.367Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
